import Vue from 'vue'

export function getFBoyList(data) {
    return Vue.axios({
        url: '/api/artists/list',
        method: 'get',
        params: {...data}
    })
}
//红人分成比例查看
export function getArtistRateList(data) {
    return Vue.axios({
        url: '/api/artists/getRateList',
        method: 'get',
        params: {...data}
    })
}

export function getFBoyOption(data) {
    return Vue.axios({
        url: '/api/artists/option',
        method: 'get',
        params: {...data}
    })
}

export function addOrEditFBoy(data) {
    return Vue.axios({
        url: '/api/artists/store',
        method: 'post',
        data: {...data}
    })
}

export function getFBoyDetail(id) {
    return Vue.axios({
        url: '/api/artists/detail',
        method: 'get',
        params: {id}
    })
}

export function banchDelete(ids) {
    return Vue.axios({
        url: '/api/artists/destroy',
        method: 'get',
        params: {ids}
    })
}

export function topfBoy(data) {
    return Vue.axios({
        url: '/api/artists/sort',
        method: 'get',
        params: {...data}
    })
}

// export function fboyFans(data) {
//     return Vue.axios({
//         url: '/api/artists/fan',
//         method: 'get',
//         params: {...data}
//     })
// }
//
// export function queryArtist(data) {
//     return Vue.axios({
//         url: '/api/artists/queryArtist',
//         method: 'get',
//         params: {...data}
//     })
// }

export function platformDelete(data) {
    return Vue.axios({
        url: '/api/artists/platformDelete',
        method: 'get',
        params: {...data}
    })
}



